export default __webpack_public_path__ + "static/media/img3.94482c57.jpg";